import { HeaderText } from "./Components";
import React, { useRef } from "react";
import styled from "styled-components";
import Navbar from "../Navbar/Navbar";
import Sidebar from "./SiderBar";
import BodyContent from "./BodyContent";
import Footer from "../Footer/Footer";

export const NavbarWrapper = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 3rem;
  z-index: 1000;
  background-color: white;
`;

const Container = styled.div`
  background-size: cover;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const SidebarContainer = styled.div`
  @media (max-width: 950px) {
    display: none;
  }
  flex: 0 0 auto;
  position: fixed;
  top: 0;
  width: 25%;
  left: 0;
  bottom: 0;
  background-color: white;
  padding: 20px;
`;

const Content = styled.div`
  @media (max-width: 950px) {
    padding: 0px;
    margin: 0px;
  }
  display: flex;
  flex: 1;
  overflow-y: auto;
  align-items: center;
  margin-left: 25%;
`;

const FooterWrapper = styled.div`
  @media (max-width: 950px) {
    margin: 0px;
  }
  display: flex;
  flex: 1;
  overflow-y: auto;
  align-items: center;
  margin-left: 25%;
`;

const BodyContainer = styled.div`
  margin: 20px 30px 20px 50px;
  @media (max-width: 950px) {
    padding: 0px;
    margin: 30px 20px;
  }
`;

interface Section {
  heading: string;
  content: { type: string; value: string | string[] }[];
}

interface PageProps {
  pageTitle: string;
  sections: Section[];
}

const scrollToSection = (
  index: number,
  sectionsRefs: React.MutableRefObject<(HTMLDivElement | null)[]>
) => {
  if (sectionsRefs.current[index]) {
    const offset = window.innerHeight / 3;
    const targetPosition = sectionsRefs.current[index]!.offsetTop - offset;
    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  }
};

const Page: React.FC<PageProps> = ({ pageTitle, sections }) => {
  const sectionsRefs = useRef<(HTMLDivElement | null)[]>([]);

  return (
    <Container>
      <NavbarWrapper>
        <Navbar />
      </NavbarWrapper>
      <SidebarContainer>
        <Sidebar
          headings={sections.map((section) => section.heading)}
          scrollToSection={(index) => scrollToSection(index, sectionsRefs)}
        />
      </SidebarContainer>
      <Content>
        <BodyContainer>
          <HeaderText>{pageTitle}</HeaderText>
          {sections.map((section, index) => (
            <div key={index} ref={(ref) => (sectionsRefs.current[index] = ref)}>
              <BodyContent
                heading={section.heading}
                content={section.content}
              />
            </div>
          ))}
        </BodyContainer>
      </Content>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Container>
  );
};

export default Page;
